import { render, staticRenderFns } from "./PgoPublishConfirmation.vue?vue&type=template&id=49f2cf84&"
import script from "./PgoPublishConfirmation.vue?vue&type=script&lang=js&"
export * from "./PgoPublishConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports